import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ProtectedRoute } from './ProtectedRoute';
import { pickRoutes } from './pickRoutes';
import { Login } from '../pages/Login/Login';
import { Tracking } from '../pages/Tracking/Tracking';
import { TrackingGT } from '../pages/Tracking/TrackingGT';
import { TrackOrder } from '../pages/Tracking/TrackOrder';
import {
  selectIsStaff,
  selectLegacyProfile,
  selectRole,
} from '../features/auth/authSelectors';

export const AppRouter = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const role = useSelector(selectRole);

  const isStaff = useSelector(selectIsStaff);

  // Two profiles have their workspace in the front this one is replacing. The
  // decision lives here rather than in the login thunk because `auth` is the
  // one persisted slice: everybody already signed in rehydrates straight into
  // the router without passing through `loginUser` again.
  const legacyProfile = useSelector(selectLegacyProfile);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to="/dashboard" />} />

        {/* Public tracking. Same addresses as the old front, because they are
            already out there in emails and WhatsApp messages. Unlike /login
            they render signed in too: an operator following a customer's link
            should see what the customer sees, not be bounced to a dashboard. */}
        <Route path="/tracking" element={<Tracking />} />
        <Route path="/globaltracking/tracking" element={<TrackingGT />} />
        <Route path="/track-order/:orderId" element={<TrackOrder />} />

        <Route element={<ProtectedRoute />}>
          {pickRoutes({ role, isStaff, legacyProfile })}
        </Route>

        {/* Fallbacks */}
        <Route path="/" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
};
